import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private readonly http: HttpClient) { }

  getHistoricoPedidos(idEmpresa: any) {
    return this.http.get<any>(`/apiconnect/file-summary/report/last-orders/companies/${idEmpresa}`);
  }

  public getExtensoes(nomeTela:any){
    return this.http.get(`/apiconnect/parameters-vt/file-extensions/${nomeTela}`)
  }
}
